module.exports = "https://static.wmbcdn.com/uniweb/images/c41c3b37ea405b3cb21657f01f602b6e.svg";